export default {"src":"/_next/static/media/pig-money.02ef54e5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};